<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Notifier from "../stores/notifier";

    export let category = null;
    export let closeCallback;

    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η κατηγορία ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
            }
        };

        category.name = category.name.trim();
        if (!category.name) {
            Notifier.showError("Πληκτρολογήστε το όνομα της κατηγορίας!");
            setFocusTo("categoryName");
            return;
        }

        let action = category.id == 0 ? 'create' : 'edit';
        R.handle(R.documentCategory[action], category, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        category = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    setFocusTo("categoryName");
</script>

{#if category}
    <Modal title="Κατηγορία Εγγράφων" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Όνομα κατηγορίας</label>
                <input type="text" class="form-control" id="categoryName" bind:value="{ category.name }">
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}